export * from '@devstroupe/services/splash-screen/splash-screen.service';
